'use client';

import dynamic from 'next/dynamic';

const CookieConsent = dynamic(
  () => import('@/components').then((mod) => ({ default: mod.CookieConsent })),
  { ssr: false },
);

export default function CookieConsentClient() {
  return <CookieConsent />;
}
